import React, {useState} from 'react';


const SproutQuestionVideo: React.FC<{
  id: string;
  security_token:string;
  skip:number;
  className?:string;
  volume: number;
  showcontrols: boolean;
  autoPlay?:boolean
  seekBar?:boolean
  bigPlayButton?:boolean
  ref:any
}> = ({
  id,
  security_token,
  skip,
  className,
  volume,
  showcontrols,
  autoPlay,
   seekBar,
   ref

}) => {

  const [videoId,setVideoId] = useState(id)
  console.log("SproutQuestionVideo",videoId);

  return (
    <div className={className}>
       <iframe
        id={videoId}
        style={{borderRadius:'13px'}}
        title="Presentation Video"
        className="sproutvideo-player"
        src={`https://videos.sproutvideo.com/embed/${videoId}/${security_token}?showControls=true&volume=1&autoPlay=false`}
        width="100%"
        ref={ref}
        height="100%"
        allowFullScreen
      ></iframe>
    </div>
  )
}

export default SproutQuestionVideo;

